module.exports = __webpack_public_path__ + "static/media/not-found-404-circled.4a6366fd.svg";